import { Injector } from "@angular/core";
import { BaseNode } from "../../BaseNode";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { SourceAutoUploadEntity } from "./SourceAutoUploadEntity";
import { SubstanceInternationalCodeEntity } from "../../../Data/MedicinalProductData/SubstanceInternationalCodeEntity";
import { environment } from "../../../../../../environments/environment";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";

export class TreeNodeSubstanceInternationalCode extends BaseNode {
    
    useHist: boolean = false;
    cloningNode: boolean = false;
    items: any;
    constructor(injector: Injector, cloningNode: boolean, model: any, parent:any) {

        super(injector,
            new SubstanceInternationalCodeEntity(injector, model),
            `${model.substancename}`);

        this.parent=parent;
        this.items = model;
        this.cloningNode = cloningNode;
        if (this.cloningNode) {
            return;
        }        
        this.ioc!.get(Art57Section).generateNumColumValue(this);

        if (model.sourcecode){
            this.children?.push(new SourceAutoUploadEntity(this.ioc!, model.sourcecode.value + " - " + model.sourcecode.name, this, model.source, this.useHist, true, false));
        }

    }

    public getListItem(): any[] {
        return [this.data.model.sourcecode.name, this.data.model.substancename];
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {

      let clonedNode: TreeNodeSubstanceInternationalCode = new TreeNodeSubstanceInternationalCode(
        this.ioc!,
        true,
        this.data.model,
        newParent
      );
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));

      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)
 
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.cloningNode = false;
      return clonedNode;
    }     
}